export enum ChuteModeType {
  ON = 1,
  OFF = 0
}
